"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var create_exports = {};
__export(create_exports, {
  badRequestError: () => badRequestError,
  duplicateError: () => duplicateError,
  expiredAuthorizationError: () => expiredAuthorizationError,
  forbiddenError: () => forbiddenError,
  internalError: () => internalError,
  invalidAuthorizationError: () => invalidAuthorizationError,
  mapQueryUnsupportedError: () => mapQueryUnsupportedError,
  missingAuthorizationError: () => missingAuthorizationError,
  networkError: () => networkError,
  notFoundError: () => notFoundError,
  validationError: () => validationError
});
module.exports = __toCommonJS(create_exports);
var import_core = require("../core/index.js");
function expiredAuthorizationError(timestamp = (0, import_core.nowTimestamp)()) {
  return {
    type: "ExpiredAuthorizationError",
    timestamp
  };
}
function invalidAuthorizationError(timestamp = (0, import_core.nowTimestamp)()) {
  return {
    type: "InvalidAuthorizationError",
    timestamp
  };
}
function missingAuthorizationError(timestamp = (0, import_core.nowTimestamp)()) {
  return {
    type: "MissingAuthorizationError",
    timestamp
  };
}
function forbiddenError(check, user, timestamp = (0, import_core.nowTimestamp)()) {
  return {
    type: "ForbiddenError",
    check,
    userId: user?.id,
    roles: user?.roles,
    timestamp
  };
}
function badRequestError(message, extraData, timestamp = (0, import_core.nowTimestamp)()) {
  return {
    type: "BadRequestError",
    message,
    extraData,
    timestamp
  };
}
function notFoundError(itemType, item, timestamp = (0, import_core.nowTimestamp)()) {
  return {
    type: "NotFoundError",
    itemType,
    item,
    timestamp
  };
}
function duplicateError(itemType, item, timestamp = (0, import_core.nowTimestamp)()) {
  return {
    type: "DuplicateError",
    itemType,
    item,
    timestamp
  };
}
function mapQueryUnsupportedError(layerId, message, timestamp = (0, import_core.nowTimestamp)()) {
  return {
    type: "MapQueryUnsupportedError",
    layerId,
    message,
    timestamp
  };
}
function internalError(message, timestamp = (0, import_core.nowTimestamp)()) {
  return {
    type: "InternalError",
    message,
    timestamp
  };
}
function validationError(value, errors, message, status, timestamp = (0, import_core.nowTimestamp)()) {
  return {
    type: "ValidationError",
    value,
    errors,
    message,
    status,
    timestamp
  };
}
function networkError(message, extraData = void 0, timestamp = (0, import_core.nowTimestamp)()) {
  return {
    type: "NetworkError",
    message,
    extraData,
    timestamp
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  badRequestError,
  duplicateError,
  expiredAuthorizationError,
  forbiddenError,
  internalError,
  invalidAuthorizationError,
  mapQueryUnsupportedError,
  missingAuthorizationError,
  networkError,
  notFoundError,
  validationError
});
//# sourceMappingURL=create.js.map
